import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { ClientsListScreen } from '@/features/clients/clients-list-screen'
import { NewClientDialog } from '@/features/clients/new-client-dialog'

export const Route = createFileRoute('/_app/clients/')({ component: ClientsPage })

/// Список і діалог створення живуть разом: `F3` і кнопка «Новий клієнт» ведуть
/// в один і той самий діалог, а після успіху — на картку створеної людини.
function ClientsPage() {
  const navigate = useNavigate()
  const [isCreating, setIsCreating] = useState(false)

  const handleNewClient = () => setIsCreating(true)
  const handleOpenClient = (clientId: string) => {
    setIsCreating(false)
    void navigate({ to: '/clients/$clientId', params: { clientId } })
  }

  return (
    <>
      <ClientsListScreen onNewClient={handleNewClient} />
      <NewClientDialog
        open={isCreating}
        onOpenChange={setIsCreating}
        onOpenClient={handleOpenClient}
      />
    </>
  )
}
